import * as React from "react";
import { UIDataModel } from "../../uicomponent";
import { UIComponentViewImpl } from "../../uicomponentview";
import { FloatingTextComponentHandler } from "../floatingtextcomponent";
import { PasswordTextComponentHandler, PasswordTextComponentProps, PasswordTextComponentState } from "./passwordtextcomponent";
import { PasswordTextCSSStyle } from "./passwordtextcss";


export class PasswordTextViewImpl extends UIComponentViewImpl<UIDataModel>
{
    bindHandlers()
    {
        this.onChange = this.onChange.bind(this);
        this.toggleShow = this.toggleShow.bind(this);
       
    }

    draw(props: PasswordTextComponentProps, state: PasswordTextComponentState, cssStyle: PasswordTextCSSStyle): JSX.Element | boolean
    {    
         return (
                <div style={cssStyle.getWrapperCSSStyle()}>
                    <h1 className={state.class}>{props.placeholder}</h1>
                      <div style={cssStyle.getPasswordDivCSSStyle()}>
                        <input value={state.value} type={state.hidden? "password":"text"} onChange={this.onChange} onKeyDown={props.inputType === "number"? this.onKeyPress : ()=>""} style={state.errorMessage !== undefined ? cssStyle.getErrorCSSStyle() : cssStyle.getTextCSSStyle(state.class === "" ? false : true)} placeholder={props.placeholder}/>
                      {
                          state.hidden? <img style={{width:"20px", height:"20px"}} onClick={this.toggleShow} src={this.getContext().getResources().getImage("eye_disabled.svg")}/>:
                          <img style={cssStyle.getEyeIconCSSStyle()} onClick={this.toggleShow} src={this.getContext().getResources().getImage("eye.svg")}/>} 
                      </div>
                       
                    {
                        state.errorMessage !== undefined && <div style={cssStyle.getErrorTextDivCSSStyle()}>
                        <label style={cssStyle.getErrorTextCSSStyle(this.getContext().getUserContext().getLanguage())}>{state.errorMessage}</label> </div>}
                </div>
       );
    }


     toggleShow():void{
         (this.getUIComponentHandler() as PasswordTextComponentHandler).toggleShow();
     }
  
    onChange(event: any)
    {
        (this.getUIComponentHandler() as FloatingTextComponentHandler).onChange(event.target.value);
    }
     onKeyPress(event:any)
    {
        if(event.keyCode === 69 || event.keyCode === 187 || event.keyCode === 190 || 
            event.keyCode === 189 || (event.ctrlKey && event.keyCode === 90) ||
            (event.ctrlKey && event.keyCode === 67) || (event.ctrlKey && event.keyCode === 86) ||
            (event.ctrlKey && event.keyCode === 88))
        {
            event.preventDefault();
        }
    }

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/floatingtext/password/passwordtextview.tsx